module.exports = __webpack_public_path__ + "img/SA.15a5ff93.png";